export var STATUS = {
  ACTIVE: 'ACTIVE',
  APPROVED: 'APPROVED',
  CLOSED: 'CLOSED',
  DRAFT: 'DRAFT',
  READY_TO_SUBMIT: 'READY_TO_SUBMIT',
  ERROR: 'ERROR',
  DRAFTED: 'DRAFTED',
  IN_ACTIVE: 'INACTIVE',
  IN_ACTIVE_NEW: 'IN_ACTIVE',
  IN_REVIEW: 'IN_REVIEW',
  ON_HOLD: 'ON_HOLD',
  OPEN: 'OPEN',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PENDING: 'PENDING',
  PARTIALLY_PENDING: 'PARTIALLY_PENDING',
  POSTED: 'POSTED',
  POSTING: 'POSTING',
  REJECTED: 'REJECTED',
  ARCHIVED: 'ARCHIVED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  DEPOSITED: 'DEPOSITED',
  OUTSTANDING: 'OUTSTANDING',
  EXPIRED: 'EXPIRED',
  PAST_DUE: 'PAST_DUE',
  VOID: 'VOID',
  VOIDING: 'VOIDING',
  DELINQUENT: 'DELINQUENT',
  RE_OPENED: 'RE_OPENED',
  CLOSING_IN_PROGRESS: 'CLOSING_IN_PROGRESS',
  SCHEDULED: 'SCHEDULED',
  SUBMITTED: 'SUBMITTED',
  PARTIALLY_RETURNED: 'PARTIALLY_RETURNED',
  VOIDED: 'VOIDED',
  ORDERED_THEN_VOIDED: 'ORDERED_THEN_VOIDED',
  SERVICE_RETURNED: 'SERVICE_RETURNED',
  NON_RETURNABLE: 'NON_RETURNABLE',
  RECEIVED: 'RECEIVED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  PENDING_RECEIPT: 'PENDING_RECEIPT',
  REISSUED: 'REISSUED',
  ORDERED: 'ORDERED',
  REQUESTED: 'REQUESTED',
  CLEARED: 'CLEARED',
  SUCCESS: 'SUCCESS',
  INVOICED: 'INVOICED',
  PRINTED: 'PRINTED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  PARTIALLY_CLEARED: 'PARTIALLY_CLEARED',
  DONE: 'DONE',
  DRAFTED_THEN_VOIDED: 'DRAFTED_THEN_VOIDED',
  PAID: 'PAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  VOID_INITIATED: 'VOID_INITIATED',
  PRE_INVOICED: 'PRE_INVOICED',
  APPROVAL_DRAFT: 'APPROVAL_DRAFT',
  COUNT_COMPLETED: 'COUNT_COMPLETED',
  UNASSIGNED: 'UNASSIGNED',
  PARTIALLY_ASSIGNED: 'PARTIALLY_ASSIGNED',
  TECH_ASSIGNED: 'TECH_ASSIGNED',
  READY_FOR_INVOICE: 'READY_FOR_INVOICE',
  REVIEW_REQUESTED: 'REVIEW_REQUESTED',
  PUBLISHED: 'PUBLISHED',
  OEM_CONFIRMATION_PENDING: 'OEM_CONFIRMATION_PENDING',
  FINANCE_AND_INSURANCE: 'FINANCE_AND_INSURANCE',
  PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
  DELIVERED: 'DELIVERED',
  QUOTE: 'QUOTE',
  BOOKED: 'BOOKED',
  REOPENED: 'REOPENED',
  UNVERIFIED: 'UNVERIFIED',
  LOST: 'LOST',
  SOLD: 'SOLD',
  COMPLETE: 'COMPLETE',
  IN_COMPLETE: 'INCOMPLETE',
  HOLD: 'HOLD',
  PRE_CLOSED: 'PRE_CLOSED',
  NA: 'NA',
  FULFILLED: 'FULFILLED',
  NOT_DRAFTED: 'NOT_DRAFTED',
  PROCESSED: 'PROCESSED',
  CONDITIONED: 'CONDITIONED',
  DECLINED: 'DECLINED',
  WITHDRAWN: 'WITHDRAWN'
};